import React from 'react';
import './Hero.css';

// ✅ Import your video here!
import heroVideo from '../utility/Landing.mp4'; 

const Hero = ({ onExplore }) => {
  return (
    <section className="hero">
      <div className="hero-container">
        
        {/* 1. THE VIDEO COMES FIRST */}
        <div className="hero-visual">
          <div className="video-wrapper">
            <video 
              autoPlay 
              loop 
              muted 
              playsInline 
              className="hero-video"
            >
              <source src={heroVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            
            {/* Optional: A glass overlay element over the video to make it look premium */}
            <div className="video-glass-badge">
              <span className="live-dot"></span> Live Interactive Sessions
            </div>
          </div>
        </div>

        {/* 2. THE TEXT COMES SECOND */}
        <div className="hero-content">
          <h1 className="hero-title">
            Transform Your <span className="highlight">Career</span> with TrekVerse
          </h1>
          <p className="hero-subtitle">
            Explore industry-leading programs across Tech, Electronics, Management & Civil domains.
            Join thousands of professionals advancing their skills.
          </p>
          <button className="explore-btn" onClick={onExplore}>
            Explore Programs
            <span className="arrow">→</span>
          </button>
        </div>

      </div>

      {/* The background glowing orbs */}
      <div className="hero-background">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div>
    </section>
  );
};

export default Hero;